module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    class: {
      flex: true, 'use-login': _vm.SITE_CONFIG.use_login
    }
  }, [(_vm.SITE_CONFIG.use_login) ? _c('div', [(!_vm.loggedIn) ? _c('h2', [_vm._v(_vm._s(_vm.$t('user.login-title')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blocked info"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('texts.texts-checkout_login_info'))
    }
  })]), _vm._v(" "), _c('Login')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [(_vm.SITE_CONFIG.use_login) ? _c('div', [(!_vm.loggedIn) ? _c('h2', [_vm._v(_vm._s(_vm.$t('user.login-go-on-anyway')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "choices"
  }, [_c('div', [(!_vm.$store.state.isOnSite) ? _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": _vm.yes,
      "value": 1,
      "valuebinder": _vm.gdpr_newsletter
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.gdpr_newsletter = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(!_vm.$store.state.isOnSite) ? _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": _vm.no,
      "value": 0,
      "valuebinder": _vm.gdpr_newsletter
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.gdpr_newsletter = $event
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_vm._v("\n        Bokar du för ett företag, kontakta oss på "), _c('a', {
    staticStyle: {
      "white-space": "nowrap"
    },
    attrs: {
      "href": "tel:054132600"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(".\n      ")]), _vm._v(" "), (_vm.showCountrySelector) ? _c('div', {
    staticClass: "text",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('b', [_vm._v("Select your country")]), _vm._v(" "), _c('CountrySwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    class: {
      small: true, disabled: !_vm.valid
    },
    staticStyle: {
      "margin-top": "8px"
    },
    on: {
      "click": _vm.click
    }
  }, [_vm._v(_vm._s(_vm.$store.state.cart.pincode ? _vm.$t('user.send-order') : _vm.$t('user.to-payment')))]), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "margin-top": "1.5rem",
      "margin-bottom": "1.5rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('texts.texts-gdpr_text'))
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab494338"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CheckoutLoginModal.vue
// module id = 1011
// module chunks = 0